var uiAssetClassBadge = {
	bond: "Obligation",
	commodity: "Matière Première",
	currency: "Devise",
	debt: "Dette",
	etf: "Fonds Négocié en Bourse (ETF)",
	fund: "Fonds",
	generic: "Générique",
	index: "Indice",
	stock: "Action",
	interestRate: "Taux d'Intérêt",
	structuredProduct: "Produit Structuré",
	investmentProduct: "Produit d'Investissement",
	leveragedProduct: "Produit à Effet de Levier",
	future: "Futures",
	option: "Option"
};
var fr = {
	uiAssetClassBadge: uiAssetClassBadge
};

export { fr as default, uiAssetClassBadge };
